// client/src/components/Navbar.js
import React from 'react';
import { Navbar, Nav, Button, Image } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const NavigationBar = () => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    // 1. Added align-items-center to vertically center the brand and hamburger
    <Navbar bg="light" expand="lg" className="bg-body-tertiary shadow-sm px-3 mb-4 align-items-center">
      <Navbar.Brand as={Link} to="/" className="fw-bold">Ads Board</Navbar.Brand>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">

        {/* 2. Left side nav: Added align-items-center to keep links centered with brand */}
        <Nav className="me-auto align-items-center">
          <Nav.Link as={Link} to="/">Home</Nav.Link>
          {!user && <Nav.Link as={Link} to="/login">Login</Nav.Link>}
          {!user && <Nav.Link as={Link} to="/register">Register</Nav.Link>}
          {user && <Nav.Link as={Link} to="/create-ad">Create Ad</Nav.Link>}
        </Nav>

        {/* 3. Right side profile: Removed extra <Nav> wrapper and used d-flex align-items-center */}
        {user && (
          <div className="d-flex align-items-center mt-2 mt-lg-0">
            {user.avatar && (
              <Image
                src={`/uploads/${user.avatar}`}
                roundedCircle
                width="30"
                height="30"
                className="me-2"
                style={{ objectFit: 'cover' }}
              />
            )}
            <span className="text-success me-3">Welcome, {user.login}!</span>
            <Button variant="outline-danger" onClick={handleLogout}>
              Sign Out
            </Button>
          </div>
        )}
      </Navbar.Collapse>
    </Navbar>
  );
};

export default NavigationBar;